/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.2.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NextPortCluster
 */
export interface NextPortCluster {
    /**
     * 
     * @type {string}
     * @memberof NextPortCluster
     */
    name?: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof NextPortCluster
     */
    locodes?: Array<any>;
    /**
     * Hex code for color
     * @type {string}
     * @memberof NextPortCluster
     */
    color?: string;
    /**
     * Fraction 0..1 of probability
     * @type {number}
     * @memberof NextPortCluster
     */
    threshold?: number;
    /**
     * UUID of the cluster
     * @type {string}
     * @memberof NextPortCluster
     */
    id?: string;
}

/**
 * Check if a given object implements the NextPortCluster interface.
 */
export function instanceOfNextPortCluster(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NextPortClusterFromJSON(json: any): NextPortCluster {
    return NextPortClusterFromJSONTyped(json, false);
}

export function NextPortClusterFromJSONTyped(json: any, ignoreDiscriminator: boolean): NextPortCluster {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'locodes': !exists(json, 'locodes') ? undefined : json['locodes'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'threshold': !exists(json, 'threshold') ? undefined : json['threshold'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function NextPortClusterToJSON(value?: NextPortCluster | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'locodes': value.locodes,
        'color': value.color,
        'threshold': value.threshold,
        'id': value.id,
    };
}

